<template>
  <div v-loading="isLoading" element-loading-text="Đang chuẩn bị dữ liệu..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="#f5f5f5">
    <div class="d-flex m-2 p-1">
      <el-select v-model="selectTypeOfData"
                 size="sm"
                 class="flex-1 mx-2" style="max-width: 200px">
        <el-option v-for="type in typeOfData" :key="type.val" :label="type.name"
                   :value="type.val"></el-option>
      </el-select>
      <!-- <el-select v-model="selectedAccount" filterable default-first-option
                 placeholder="Tìm kiếm tài khoản..." size="sm"
                 class="flex-1" style="max-width: 250px">
        <el-option v-for="account in accounts" :key="account.accountId" :label="getAccountName(account)"
                   :value="account.accountId"></el-option>
      </el-select> -->
      <el-select
        v-model="selectAccountIds"
        filterable
        placeholder="Chọn tài khoản"
        collapse-tags
        multiple
        clearable
        style="width: 230px">
        <el-input
          ref="search1"
          class="px-12 py-1"
          size="small"
          v-model="accountSearch"
          placeholder="Tìm kiếm tài khoản..."
          clearable
          @input="onChangeAccountSearch">
          <IconV2
            slot="prefix"
            class="my-12 ms-3"
            name="v2-search" />
        </el-input>
        <div
          class="d-flex align-items-center account-all pointer font-14"
          @click="onSelectAll">
          <span
            :class="selectAllAccount && 'account-all-active'"
            style="width: 132px">
            Tất cả tài khoản
          </span>
          <IconV2
            v-if="selectAllAccount"
            class="ms-2"
            name="v2-check"
            color="#0A58C0"
            size="0.75rem" />
        </div>

        <el-divider class="my-0" />

        <div
          v-for="account in accountsFilter"
          :key="account.accountId"
          class="d-flex align-items-center account-all pointer font-14"
          @click="onSelectAccount(account.accountId)">
          <span
            class="trim-text-1-line"
            :class="selectAccountIds.includes(account.accountId) && 'account-all-active'"
            style="max-width: 200px">
            {{ account.name }}
          </span>
          <IconV2
            v-if="selectAccountIds.includes(account.accountId)"
            class="ms-2"
            name="v2-check"
            color="#0A58C0"
            size="0.75rem" />
        </div>

        <el-option
          v-show="false"
          v-for="(account, index) in accounts"
          :key="index"
          :label="getAccountName(account).length < 15 ? getAccountName(account) : getAccountName(account).slice(0, 14) + '...'"
          :value="account.accountId"></el-option>
      </el-select>
      <el-select v-model="selectType" class="w-150px mx-2">
        <el-option v-for="item in types" :key="item.val" :label="item.name"
                   :value="item.val">
        </el-option>
      </el-select>
      <el-select v-model="selectTag" class="w-200px mx-2" v-if="selectTypeOfData=='contact'">
        <el-option label="Tất cả liên hệ (tag) " :value="0"></el-option>
        <el-option v-for="item in app.tags" :key="item.id" :label="item.name"
                   :value="item.id">
        </el-option>
      </el-select>
      <DateRangePicker v-if="selectTypeOfData=='message'"
                       size="md"
                       ref="picker"
                       opens="left"
                       :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy', applyLabel: 'Áp dụng', cancelLabel: 'Hủy' }"
                       :minDate="'2019/01/01'"
                       :singleDatePicker="false"
                       :ranges="false"
                       :showWeekNumbers="true"
                       :showDropdowns="true"
                       :autoApply="false"
                       v-model="dateRange"
                       :linkedCalendars="true"
      >
        <template v-slot:input="picker">
                <span style="line-height: 25px; padding: 0 10px;"
                >Từ <b>{{ picker.startDate.toLocaleDateString("vi") }}</b> &nbsp; &nbsp; Đến
                  <b> {{ picker.endDate.toLocaleDateString("vi") }} </b></span
                >
        </template>
      </DateRangePicker>
      <div class="mx-2">
        <el-button type="primary" size="md" @click="fetchStatistic()">Tổng hợp dữ liệu</el-button>
      </div>
    </div>

    <el-card class="m-2" v-if="slider.interval<100">
      <vue-slide-bar :speed="0.05" v-model="slider.interval" :showTooltip="false"
                     :lineHeight="10"
                     style="padding-top: 4px !important;"
                     :isDisabled="true" />
      <div class="mt-2  font-size-14">Đang tải dữ liệu {{ slider.interval }} %</div>
    </el-card>
    <el-card style="width: 500px" class="mx-3  mt-4">
      <div class="d-flex justify-content-between">
        <div class="text-primary font-size-18 mt-1">Đã tìm thấy {{ exportData.length }}
          {{ selectTypeOfData == "contact" ? "liên hệ" : "tin nhắn" }}
        </div>
        <el-tooltip class="item pointer" effect="dark" content="Tải xuống" slot="reference"
                    placement="top">
          <div>

            <div class=" pointer" v-if="exportData.length>0">
              <el-button type="primary" plain @click="exportToXLSX">
                <i class="el-icon-download" style="font-size: 18px" />
              </el-button>

            </div>

          </div>
        </el-tooltip>
      </div>
    </el-card>


  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { generateRandomString } from "@/lib/text-utils";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "ExportData",
  components: { DateRangePicker },
  data() {
    return {
      listAccId: [],
      selectAllAccount: false,
      accountsFilter: [],
      accountSearch: "",
      accounts: [],
      selectedAccount: null,
      selectAccountIds: [],

      typeOfData: [
        { name: "Xuất liên hệ", val: "contact" },
        { name: "Xuất tin nhắn", val: "message" }
      ],
      types: [
        { name: "Tất cả liên hệ", val: "all" },
        { name: "Cá nhân", val: "personal" },
        { name: "Nhóm", val: "group" },
        { name: "Zalo OA", val: "page" }
      ],
      selectType: "all",
      selectTag: 0,
      selectTypeOfData: "contact",
      dateRange: {
        startDate: new Date(),
        endDate: new Date()
      },
      overviewId: "",
      isLoading: false,
      slider: {
        interval: 100,
        total: 0,
        index: 0
      },
      exportData: [],
      json_meta: [
        [
          {
            "key": "charset",
            "value": "utf-8"
          }
        ]
      ],
      json_fields: {
        "ID liên hệ": "id",
        "Ảnh đại diện": "avatar",
        "Nhóm": "group",
        "Tin nhắn cuối": "lastContent",
        "Thời gian gửi tin nhắn cuối": "lastMessageTime",
        "page": "page",
        "Số điện thoại": "phone",
        "Biệt danh liên hệ": "swName",
        "Tên Zalo liên hệ": "toName",
        "Biệt danh tài khoản": "accountSwName",
        "Tên tài khoản": "accountName",
        "ID tài khoản": "accountId",
        "Tag": "tag",
        "Người tạo": "createBy",
        "ID Hồ Sơ": "toId"
      },
      json_fields_2: {
        "ID liên hệ": "contactId",
        "Ảnh đại diện": "avatar",
        "ID tin nhắn": {
          field: "msgId",
          callback: (value) => `'${value}`
        },
        "ID tin nhắn cha": {
          field: "quoteMsgId",
          callback: (value) => `'${value}`
        },
        "Tin nhắn": "content",
        "Thời gian": "ts",
        "Số điện thoại": "phone",
        "Biệt danh liên hệ": "swName",
        "Tên Zalo liên hệ": "toName",
        "Biệt danh tài khoản": "accountSwName",
        "Tên tài khoản": "accountName",
        "ID tài khoản": "accountId",
        "Loại tin nhắn": "msgType",
        "Tài khoản SW": "sendBy",
        "Tin gửi qua SW": "fromSw",
        "Từ khóa cấm": "words",
        "ID Hồ Sơ": "idTo"
      }
    };
  },
  watch: {
    selectAccountIds() {
      if (this.selectAccountIds.length < this.accounts.length) {
        this.selectAllAccount = false;
      } else {
        this.selectAllAccount = true;
      }
    },
    selectTypeOfData() {
      this.exportData = [];
    }
  },
  methods: {
    exportToXLSX() {
      const fields =
        this.selectTypeOfData === "contact"
          ? this.json_fields
          : this.json_fields_2;

      const data = this.exportData.map(row => {
        const obj = {};
        for (const [label, key] of Object.entries(fields)) {
          if (typeof key === "string") {
            obj[label] = row[key] || "";
          } else if (typeof key === "object" && key.field) {
            const value = row[key.field];
            obj[label] = key.callback ? key.callback(value, row) : value || "";
          }
        }
        return obj;
      });

      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Export");

      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(blob, `export-${this.selectTypeOfData}.xlsx`);
    },
    onSelectAll(e) {
      e.preventDefault();
      if (!this.selectAllAccount) {
        this.selectAccountIds = this.accounts.map((a) => a.accountId);
        this.selectAllAccount = true;
      } else {
        this.selectAccountIds = [];
        this.selectAllAccount = false;
      }
    },
    onSelectAccount(accountId) {
      const accIndex = this.selectAccountIds.findIndex((a) => a === accountId);
      if (accIndex === -1) {
        this.selectAccountIds.push(accountId);
      } else {
        this.selectAccountIds.splice(accIndex, 1);
      }
    },
    onChangeAccountSearch(name) {
      if (!name) {
        this.accountsFilter = this.accounts.map((a) => ({
          name: this.getAccountName(a),
          accountId: a.accountId
        }));
      }
      const normalizedSearch = name
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      this.accountsFilter = this.accounts
        .filter((element) => {
          const name = this.getAccountName(element);
          const normalizedElement = name
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          return normalizedElement.includes(normalizedSearch);
        })
        .map((a) => ({
          name: this.getAccountName(a),
          accountId: a.accountId
        }));
    },

    getAccounts() {
      // this.$http.get("/api/account/getAll").then(resp => {
        this.accounts = this.app.accounts;
        // this.selectedAccount = this.accounts[0].accountId;
        this.accountsFilter = this.accounts.map((a) => ({
          name: this.getAccountName(a),
          accountId: a.accountId
        }));
      // });
    },

    fetchStatistic() {
      this.exportData = [];
      this.slider.interval = 100;
      let url = "/api/statistic";
      let request = {};
      if (!this.selectAccountIds.length) {
        return this.alertError("Vui lòng chọn tài khoản!");
      }
      if (this.selectTypeOfData == "contact") {
        url += "/exportContactV2";
        this.overviewId = generateRandomString(6);
        request = {
          accountIds: this.selectAccountIds,
          type: this.selectType,
          tagId: this.selectTag ? this.selectTag : 0,
          overviewId: this.overviewId
        };
      } else {
        url += "/exportMessage";
        let startTime = this.dateRange.startDate.setHours(0, 0, 0, 0);
        let endTime = this.dateRange.endDate.setHours(23, 59, 59, 999);
        this.overviewId = startTime.toString() + "_" + endTime.toString() + "_" + new Date().getTime();
        request = {
          accountIds: this.selectAccountIds,
          type: this.selectType,
          tagId: 0,
          startTime: startTime,
          endTime: endTime,
          overviewId: this.overviewId
        };
      }
      this.$http.post(url, request).then(((res) => {
          if (this.selectTypeOfData == "contact") {
            this.slider.total = request.accountIds.length;
            if (this.slider.total > 0) {
              this.slider.index = 0;
              this.slider.interval = 0;
            }
          } else {
            this.slider.total = res.data;
            if (this.slider.total > 0) {
              this.slider.index = 0;
              this.slider.interval = 0;
            }
          }
        }
      ))
      ;
    },
    updateSlider() {
      this.slider.index += 1;
      this.slider.interval = ((this.slider.index / this.slider.total) * 100).toFixed(2);
    }
  },
  beforeDestroy() {
    this.$bus.$off("AccountIdSuccess");
  },
  created() {

    this.$bus.$on("ContactExport", (data) => {
        if (data.overviewId == this.overviewId) {
          this.updateSlider();
          data.data.forEach(item => {
            item.toId = item.id.split("_")[1];
          });
          this.exportData.push(...data.data);
        }
      }
    );
    this.$bus.$on("AccountIdSuccess", (data) => {
        if (data.overviewId == this.overviewId) {
          let f = this.listAccId.filter(p => p == data.newId);
          if (f == null || f.length == 0) {
            this.$http.get("/api/statistic/exportMessageById?id=" + data.newId, {}).then(resp => {
              this.exportData = this.exportData.concat(resp.data);
              this.updateSlider();
            });
          }
          this.listAccId.push(data.newId);
        }
      }
    );
    this.getAccounts();
    let codes = this.app.customerCodeList;
    codes.forEach((c) => {
      if (!c.hidden) {
        this.json_fields["Ghi chú - " + c.title] = c.id;
      }
    });
    console.log(this.json_fields);
  }
};
</script>

<style scoped>
.account-all {
  height: 34px;
  padding-left: 20px;
}

.account-all:hover {
  background-color: #f5f7fa;
}

.account-all-active {
  color: #0a58c0;
  font-weight: bolder;
}
</style>
